import { Tagline } from "@/ui/Tagline";
import { Form } from "@/ui/Form";
import { useState } from "react";
import styles from "./styles.module.scss";

export const MultipleForms = ({
  formId1 = "",
  formId2 = "",
  formId3 = "",
  title = "",
  subtitle = "",
  tagline,
}) => {
  const [activeForm, setActiveForm] = useState("");

  const getFormId = () => {
    switch (activeForm) {
      case "cv":
        return formId1;
      case "vacancy":
        return formId2;
      case "general":
        return formId3;
      default:
        return "";
    }
  };

  const formId = getFormId();

  return (
    <section className={styles.root}>
      <div className="container position-relative">
        <div className="mb-4">
          {tagline && (
            <Tagline className="d-block mb-3">
              <span dangerouslySetInnerHTML={{ __html: tagline }} />
            </Tagline>
          )}
          {title && (
            <h2>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </h2>
          )}
          {subtitle && (
            <div>
              <span dangerouslySetInnerHTML={{ __html: subtitle }} />
            </div>
          )}
        </div>

        <div className={styles.contentRow}>
          <div className={styles.sidebar}>
            <div
              className={`${styles.option} ${activeForm === "cv" ? styles.active : ""}`}
              onClick={() => setActiveForm("cv")}
            >
              <div className={styles.optionTitle}>I’m looking for a job </div>
              <div className={styles.optionTitle}>Upload CV</div>
            </div>
            <div
              className={`${styles.option} ${activeForm === "vacancy" ? styles.active : ""}`}
              onClick={() => setActiveForm("vacancy")}
            >
              <div className={styles.optionLabel}>I’m looking to hire</div>
              <div className={styles.optionTitle}>Register Vacancy</div>
            </div>
            <div
              className={`${styles.option} ${activeForm === "general" ? styles.active : ""}`}
              onClick={() => setActiveForm("general")}
            >
              <div className={styles.optionLabel}>General enquiry</div>
            </div>
          </div>

          <div className={styles.formWrapper}>
            {formId && <Form formId={formId} />}
            
            {!formId && (
                <div className={styles.placeholder}>
                    Please select an enquiry type from the left.
                </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MultipleForms;